import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { ChevronDown } from "lucide-react";


function FitrosFacturasComponent({
    nroFactura, handleNroFactura, title, fechaInicio, handleFechaInicio, fechaFin, handleFechaFin,
    estadosSelected, handleEstadoSelected,
    procesadoPorSelected,
    handleProcesadoSelected,
    clienteSelected, loadingCargarCliente, dataClientes, handleNameClienteSearch, handleClienteSelected,
    dataUsuarios, loadingCargarName, nameSelected, handleUsuarioNameSearch, handleNameSelected,
    montoDesde, handleMontoDesde, montoHasta, handleMontoHasta,
    dataLocales, loadingCargarLocales, localesSelected, handleSearchLocal, handleLocalSelected,
    optionsProcesados,
    optionsEstado
}) {

    const inputBaseClass = "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";

    const formatDateInputValue = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value.slice(0, 10);
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            return value.toISOString().split("T")[0];
        }
        return "";
    };

    const handleDateValue = (value, onChange) => {
        if (!value) return;
        const date = new Date(`${value}T00:00:00`);
        if (!Number.isNaN(date.getTime())) {
            onChange(date);
        }
    };

    const selectedEstadoId = estadosSelected?.id ? String(estadosSelected.id) : "";
    const selectedProcesadoPorId = procesadoPorSelected?.id ? String(procesadoPorSelected.id) : "";

    const montoDesdeValue = (montoDesde || "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const montoHastaValue = (montoHasta || "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return (
        <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200 mb-6">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4">
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Cliente (buscar)</label>
                    <Autocomplete
                        disablePortal
                        options={dataClientes}
                        fullWidth
                        loading={loadingCargarCliente}
                        value={clienteSelected || null}
                        // getOptionLabel={(option) => option?.user?.first_name + " " + option?.user?.last_name || ""}
                        //agregar la cedula al label
                        getOptionLabel={(option) => {
                            if (!option) return "";
                            const name = option?.user?.first_name && option?.user?.last_name
                                ? `${option.user.first_name} ${option.user.last_name}`
                                : option?.user?.email || "";
                            const cedula = option?.ci ? ` - ${option?.ci}` : "";
                            return name + cedula;
                        }}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                                handleNameClienteSearch(newInputValue);
                            }
                        }}
                        onChange={(event, value) => {
                            handleClienteSelected(value);
                        }}
                        loadingText={"Cargando..."}
                        noOptionsText={"No hay opciones"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f1f5f9',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingCargarCliente ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Desde (creación de la factura)</label>
                    <input
                        type="date"
                        value={formatDateInputValue(fechaInicio)}
                        onChange={(e) => handleDateValue(e.target.value, handleFechaInicio)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Hasta (creación de la factura)</label>
                    <input
                        type="date"
                        value={formatDateInputValue(fechaFin)}
                        onChange={(e) => handleDateValue(e.target.value, handleFechaFin)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Procesado por (buscar)</label>
                    <div className="relative">
                        <select
                            value={selectedProcesadoPorId}
                            onChange={(e) => {
                                const value = e.target.value;
                                const selected = optionsProcesados.find((option) => String(option.id) === value) || null;
                                handleProcesadoSelected(selected);
                                console.log("Selected procesado por:", selected);
                            }}
                            className={`appearance-none ${inputBaseClass} pr-8`}
                        >
                            <option value="">Seleccione estado</option>
                            {optionsProcesados?.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option?.label || "-"}
                                </option>
                            ))}
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
                    </div>
                </div>


                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Local (buscar)</label>
                    <Autocomplete
                        disablePortal
                        options={dataLocales}
                        fullWidth
                        loading={loadingCargarLocales}
                        value={localesSelected || null}
                        getOptionLabel={(option) => option?.nombre_fantasia || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                                handleSearchLocal(newInputValue);
                            }
                        }}
                        onChange={(event, value) => {
                            handleLocalSelected(value);
                        }}
                        loadingText={"Cargando..."}
                        noOptionsText={"No hay opciones"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f1f5f9',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingCargarLocales ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Estado</label>
                    <div className="relative">
                        <select
                            value={selectedEstadoId}
                            onChange={(e) => {
                                const value = e.target.value;
                                const selected = optionsEstado.find((option) => String(option.id) === value) || null;
                                handleEstadoSelected(selected);
                            }}
                            className={`appearance-none ${inputBaseClass} pr-8`}
                        >
                            <option value="">Seleccione estado</option>
                            {optionsEstado?.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option?.label || "-"}
                                </option>
                            ))}
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
                    </div>
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">N° de la factura</label>
                    <input
                        type="text"
                        value={nroFactura}
                        onChange={(e) => handleNroFactura(e.target.value)}
                        autoCapitalize="none"
                        autoCorrect="off"
                        placeholder="Ingresar nro de la factura"
                        className={inputBaseClass}
                    />
                </div>

                {/* <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Usuario (buscar)</label>
                    <Autocomplete
                        disablePortal
                        options={dataUsuarios}
                        fullWidth
                        loading={loadingCargarName}
                        value={nameSelected || null}
                        getOptionLabel={(option) => option?.value || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                                handleUsuarioNameSearch(newInputValue);
                            }
                        }}
                        onChange={(event, value) => {
                            handleNameSelected(value);
                        }}
                        loadingText={"Cargando..."}
                        noOptionsText={"No hay opciones"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f1f5f9',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingCargarName ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </div> */}

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Monto desde</label>
                    <input
                        type="text"
                        value={montoDesdeValue}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            handleMontoDesde(value);
                        }}
                        autoCapitalize="none"
                        autoCorrect="off"
                        placeholder="Ingresar monto desde"
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Monto hasta</label>
                    <input
                        type="text"
                        value={montoHastaValue}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            handleMontoHasta(value);
                        }}
                        autoCapitalize="none"
                        autoCorrect="off"
                        placeholder="Ingresar monto hasta"
                        className={inputBaseClass}
                    />
                </div>
            </div>

        </div>
    );
}

export default FitrosFacturasComponent;